import { z } from 'zod';

/**
 * The single URL allowlist for the platform. Accepts https/http/mailto/tel, a
 * root-relative path ("/…"), or a fragment ("#…"). Protocol-relative ("//evil.com"
 * or "/\evil.com") is rejected — it reads as root-relative but browsers treat it
 * as absolute (the same trap as the docs returnTo redirect). Everything else —
 * javascript:, data:, vbscript:, etc. — is rejected.
 */
export function isSafeUrl(u: string): boolean {
  const s = u.trim();
  if (!s) return false;
  if (s.startsWith('//') || s.startsWith('/\\')) return false;
  return /^(https?:\/\/|mailto:|tel:|\/|#)/i.test(s);
}

export const safeUrl = z.string().refine(isSafeUrl, { message: 'unsupported URL scheme' });
export const safeUrlOptional = safeUrl.optional();
